import isInstance from './isInstance.js';

const isString = (x) => isInstance(String, x);
export default isString;
